import { render, staticRenderFns } from "./SectionBanner.vue?vue&type=template&id=57535268&"
import script from "./SectionBanner.vue?vue&type=script&lang=ts&"
export * from "./SectionBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports